<template><section><template>
<h3>开关</h3>
<div class="bs-docs-section">
<div class="bs-example">
<p></p><h3><n3-switch v-model="value"></n3-switch></h3><p></p>
<p></p><h3><n3-switch ontext="开" offtext="关" @change="toggle" v-model="value"></n3-switch></h3><p></p>
<p></p><h3><n3-switch ontext="开" offtext="关" @change="toggle" :disabled="true"></n3-switch></h3><p></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">ontext</span>=<span class="hljs-string">"开"</span> <span class="hljs-attr">offtext</span>=<span class="hljs-string">"关"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"toggle"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-switch</span> <span class="hljs-attr">ontext</span>=<span class="hljs-string">"开"</span> <span class="hljs-attr">offtext</span>=<span class="hljs-string">"关"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"toggle"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-switch</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>disabled</td>
<td><code v-pre="">boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁用</td>
</tr>
<tr>
<td>ontext</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">ON</code></td>
<td>开文案</td>
</tr>
<tr>
<td>offtext</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">OFF</code></td>
<td>关文案</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁用</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>值变化</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value: false
    }
  },
  methods: {
    toggle (state) {
      console.log(state)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3SwitchDocs.md?9e0ff87e